<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">检验单号</label>
            <span class="weui-form-preview__value">{{initData.qc_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">检验日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.qc_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">制造单号</label>
            <span class="weui-form-preview__value">{{initData.qc_macode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">班次</label>
            <span class="weui-form-preview__value">{{initData.qc_work_class}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">工作中心</label>
            <span class="weui-form-preview__value">{{initData.qc_wcname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">线别</label>
            <span class="weui-form-preview__value">{{initData.qc_product_lines}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">QC位</label>
            <span class="weui-form-preview__value">{{initData.qc_station}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">检验数量</label>
            <span class="weui-form-preview__value">{{initData.qc_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良品数</label>
            <span class="weui-form-preview__value">{{initData.qc_ngqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良率</label>
            <span class="weui-form-preview__value">{{initData.qc_ng_rate}}%</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良现象</label>
            <span class="weui-form-preview__value">{{initData.qd_ng_reason}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不良数量</label>
            <span class="weui-form-preview__value">{{initData.qd_qty}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object,
  }
};
</script>